import { useAppSelector } from "../../../../hooks/useRedux"
import CustomLineSlider from "../CustomLineSlider"

interface Props {
    width: number
    thumbHeight: number | undefined
    visibility: "visible" | "hidden"
    handleChange: (val: number) => void
}

const TimelinePlayhead = ({ width, thumbHeight, visibility, handleChange }: Props) => {
    const masterTimeline = useAppSelector((state) => state.masterTimeline.value)

    if (!masterTimeline) {
        return <></>
    } else
        return (
            <div
                className="custom-line-slider"
                style={{
                    width: width,
                    position: "absolute",
                    height: "10px",
                    top: -15,
                    zIndex: 60,
                    visibility: visibility,
                }}
            >
                <CustomLineSlider
                    thumbHeight={thumbHeight ? thumbHeight + 15 * 2 : 0}
                    handleChange={handleChange}
                />
            </div>
        )
}

export default TimelinePlayhead
